import type { RuntimeConfig } from 'umi';
import { App } from 'antd';
import { history } from 'umi';

// Guard against multiple 401 redirects causing infinite refresh
let redirectingToLogin = false;

export function rootContainer(container: any) {
  return <App>{container}</App>;
}

export const request: RuntimeConfig['request'] = {
  timeout: 30000,
  errorConfig: {
    errorThrower: () => {},
    errorHandler: (error: any) => {
      if (error?.response?.status === 401) {
        // Prevent infinite redirect loop when multiple requests fail with 401
        if (redirectingToLogin) return;
        // Don't redirect if already on the login page
        if (window.location.pathname === '/login') return;

        redirectingToLogin = true;
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        history.replace('/login');
        // Reset guard after navigation completes
        setTimeout(() => { redirectingToLogin = false; }, 1000);
      }
    },
  },
  requestInterceptors: [
    (config: any) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
      }
      return config;
    },
  ],
};
